import PartnerRewardsCard from './PartnerRewardsCardContainer';

export default PartnerRewardsCard;
